






















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import { validation as formValidate } from '@/views/Onboarding/Steps/Refund/validation';
import { configFormDataFactory } from '@/views/Onboarding/helpers';
import Typography from '@/components/atoms/Typography/Typography.vue';
import ConfigRadio from '@/components/molecules/ConfigRadio/ConfigRadio.vue';

import { ConfigFormData, ConfigFormDataValueType } from '@/models/onboarding';

import { pluralize } from '@/utils';

export const DEFAULT_VALUES = [0, 14, 30, 60];

@Component({
  components: {
    Typography,
    ConfigRadio
  }
})
export default class RefundConfigForm extends Vue {
  @Prop() defaultSelectValues?: number[];
  @Prop() defaultFormData?: ConfigFormData;
  @Prop({ default: true }) loadBusinessData?: boolean;
  @Prop({ default: 99 }) inputMax?: number;
  @Prop() customLabelDescription?: string;
  formData: any = this.defaultFormData || this.getInitialFormData();
  defaultValues = this.defaultSelectValues || DEFAULT_VALUES;

  get tPrefix() {
    return 'common.components.refundConfigForm';
  }

  get isActiveCustomRadio() {
    const { customValue, customValueFocused } = this.formData;

    const valueIsNumber = typeof customValue === 'number';

    return valueIsNumber && !customValueFocused;
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get businessRegistrations() {
    return this.$store.getters['registration/getBusinessRegistration'];
  }

  get alreadySetRefundPolicy() {
    if (!this.businessRegistrations) return [];

    return this.businessRegistrations
      .filter(
        (registration: any) =>
          registration.businessSignupSteps[0].status === 'seen'
      )
      .map(({ slug }: any) => slug)
      .includes('return-policy');
  }

  @Watch('formData', { deep: true })
  onChange() {
    this.$emit('change', this.formData);
  }

  @Watch('businessInfo', { immediate: true })
  fillFormData() {
    if (!this.businessInfo) return;

    this.formData =
      this.defaultFormData &&
      (!this.loadBusinessData || formValidate(this.defaultFormData))
        ? this.defaultFormData
        : this.getInitialFormData();
  }

  getInitialFormData(): ConfigFormData {
    const business = this.businessInfo;

    if (!business) return configFormDataFactory();

    if (business.refundsLimitDays == null) return configFormDataFactory();

    const refundsLimitDays = Number(business.refundsLimitDays);
    const isValidValue = !isNaN(refundsLimitDays);

    const valueExistsInDefaultValues = this.defaultValues.includes(
      refundsLimitDays
    );

    if (!isValidValue) {
      return configFormDataFactory();
    }

    if (valueExistsInDefaultValues) {
      return Object.assign(this.formData, configFormDataFactory(), {
        value: refundsLimitDays,
        type: 'default',
        state: {
          [refundsLimitDays]: true
        }
      });
    }

    return Object.assign(this.formData, configFormDataFactory(), {
      customValue: refundsLimitDays,
      type: 'custom',
      state: {
        [refundsLimitDays]: true
      }
    });
  }

  isInstantly(value: number | string) {
    return value === 0;
  }

  getLabel(value: number | string) {
    if (this.isInstantly(value)) {
      return this.$t(`${this.tPrefix}.labels.noWaiting`);
    }

    return `${pluralize(
      value as number,
      String(this.$t(`${this.tPrefix}.labels.day`))
    )} ${this.$t(`${this.tPrefix}.labels.later`)}`;
  }

  getLabelValue(value: number | string) {
    if (this.isInstantly(value)) {
      return this.$t(`${this.tPrefix}.labels.instantly`);
    }

    return value;
  }

  handleClickDefaultRadio(value: number, type: ConfigFormDataValueType) {
    const { state } = this.formData;

    Object.assign(this.formData, { customValue: '' });

    if (!state[value]) {
      Object.assign(this.formData, {
        value,
        type,
        state: {
          [value]: true
        }
      });

      return;
    }

    Object.assign(this.formData, configFormDataFactory());
  }

  handleClickCustomRadio(type: ConfigFormDataValueType) {
    Object.assign(this.formData, { type, value: 0, state: {} });
  }

  handleInputStateFocus(focused: boolean) {
    Object.assign(this.formData, { customValueFocused: focused });
  }
}
